import sound from './activate.wav';export default sound;